

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { DataServiceService } from '../data-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataServiceService } from 'src/app/data-service.service';
import * as moment from 'moment';
import { param } from 'jquery';
import { ActivatedRoute } from '@angular/router';
import { CounsellingService } from '../counselling.service';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-student-counselling',
  templateUrl: './student-counselling.component.html',
  styleUrls: ['./student-counselling.component.scss']
})
export class StudentCounsellingComponent implements OnInit {
  // @Input() max: any;
  // today:any;
  // @ViewChild("theMenu") theMenu: MatMenuPanel;

  // getMenu() {
  //   return this.theMenu;
  // }

  casenote: any
  date: any
  @ViewChild('inputField') inputField: any;
  @ViewChild('inputField1') inputField1: any;
  @ViewChild('inputField2') inputField2: any;
  @ViewChild('inputField3') inputField3: any;
  @ViewChild('inputField4') inputField4: any;
  @ViewChild('inputField5') inputField5: any;
  @ViewChild('inputField6') inputField6: any;
  @ViewChild('inputField7') inputField7: any;
  @ViewChild('inputField8') inputField8: any;
  @ViewChild('inputField9') inputField9: any;
  @ViewChild('inputField10') inputField10: any
  @ViewChild('inputField11') inputField11: any;
  @ViewChild('inputField12') inputField12: any;
  @ViewChild('inputField13') inputField13: any;
  @ViewChild('inputField14') inputField14: any;
  // @ViewChild('inputField15') inputField15: any;
  // @ViewChild('inputField16') inputField16: any;
  // @ViewChild('inputField17') inputField17: any;
  // @ViewChild('inputField18') inputField18: any;
  // @ViewChild('inputField19') inputField19: any;
  @ViewChild('counseldate11') counseldate11: any;
  @ViewChild('casenotechecked') casenotechecked: any;

  currentDate: any = new Date();
  txtApappearanceValue: string = ""
  txtAttitudeValue: string = ''
  MotorBehaviourValue: string = ''
  PerceptionsValue: string = ''
  AffectValue: string = ''
  MoodValue: string = ''
  SpeechValue: string = ''
  Orientations: string = ''
  thoughtContentValue: string = ''
  thoughtProcessValue: string = ''
  MemoryConcentrationValue: string = ''
  radioValue: string = ""
  radioValues: string = ""



  characterCount: any = 0
  sumbited = false
  totalBehavioralReasons: any = 0;
  totalSocialConcerns: any = 0;
  totalselfAcademic: any = 0;
  totalAppearance: any = 0;
  totalAttitude: any = 0;
  totalMotorBehaviour: any = 0;
  totalPerceptions: any = 0;
  totalAffect: any = 0;
  totalMood: any = 0;
  totalSpeech: any = 0;
  totalOrientation: any = 0;
  totalThoughtContent: any = 0;
  totalThoughtProcess: any = 0;
  totalMemoryconcentration: any = 0;
  totalInsightJudgment: any = 0;
  totalacademicconcerns: any = 0;
  totalselfharmsuicidaltendencies: any = 0;
  totalconcernscognition: any = 0;
  totalpersonalconcerns: any = 0;
  totalEnviornmentalConcerns: any = 0;

  appearanceOther: any = 0;
  user: any;
  ref: any;
  searchCriteria: string = '';
  searchreffered: string = '';
  data: any;
  profileForm!: FormGroup;

  studentData: any;
  BehavioralReasons: any;
  SocialConcerns: any;
  selfAcademic: any;
  Appearance: any;
  Attitude: any;
  MotorBehaviour: any;
  Perceptions: any;
  Affect: any;
  Mood: any;
  Speech: any;
  Orientation: any;
  ThoughtContent: any;
  ThoughtProcess: any;
  Memoryconcentration: any;
  InsightJudgment: any;

  searchKey: any;
  stdCounselReasons: any = []

  behavioral: boolean = false
  socialconcerns: boolean = false
  selfacademic: boolean = false
  appearance: boolean = false;
  attitude: boolean = false;
  motorBehaviour: boolean = false;
  perceptions: boolean = false;
  affect: boolean = false;
  mood: boolean = false;
  speech: boolean = false;
  thoughtContent: boolean = false;
  thoughtProcess: boolean = false;
  memoryconcentration: boolean = false;
  orientation: boolean = false;
  thoughtProcessradio: boolean = false;
  memoryradio: boolean = false;
  selectedOption: boolean = false;
  thoughtProcessradios: boolean = false



  referredBy: any;
  anyOtherReasons: any;
  familyHistory: any;
  caseHistory: any;
  refferalIfAny: any;
  clinicalPsychologist: any
  psychiatrist: any;
  throughtContent: any;
  throughtContents: any;

  isInputDisabled: boolean = false;
  isButtonDisabled: boolean = false;

  maxDates: any
  today = new Date();
  min: any;
  lastFollowUpDate: any;
  outCome: any;
  accessDenied: boolean = false;
  councelDateCustomeFormat: string = ""

  retrievedData: any;
  retrievedData1: any;
  AcademicConcerns: any[];
  EnviornmentalConcerns: any[];
  PersonalConcerns: any[];
  ConcernsCognition: any[];
  SelfharmSuicidalTendencies: any[];



  constructor(private dataService: CounsellingService, private fb: FormBuilder, private snackbar: MatSnackBar, public http: HttpClient, private route: ActivatedRoute, private toast: ToastmessageService) {

    this.today.setDate(this.today.getDate());

    this.selectedOption = false;
    this.profileForm = this.fb.group({
      referredBy: ["", Validators.required],
      anyOtherReasons: ["", Validators.required],
      caseHistory: ["", Validators.required],
      familyHistory: ["", Validators.required],
      caseNotes: ["", Validators.required],
      counselDate: ["", Validators.required],
      followUp: ["", Validators.required],
      outCome: ["", Validators.required],
      refferalIfAny: ["", Validators.required],
      clinicalPsychologist: ["", Validators.required],
      psychiatrist: ["", Validators.required],
      behavioral: ["", Validators.required],
      socialconcerns: ["", Validators.required],
      selfacademic: ["", Validators.required],
      appearance: ["", Validators.required],
      attitude: ["", Validators.required],
      motorBehaviour: ["", Validators.required],
      perceptions: ["", Validators.required],
      affect: ["", Validators.required],
      mood: ["", Validators.required],
      speech: ["", Validators.required],
      Orientation: ["", Validators.required],
      thoughtContent: ["", Validators.required],
      thoughtProcess: ["", Validators.required],
      MemoryConcentration: ["", Validators.required],
      followUpdate: ["", Validators.required],

    })
    this.maxDates = new Date().toISOString().split('T')[0]
  }
  ngOnInit(): void {
    this.retrievedData = localStorage.getItem('userName');
    this.retrievedData1 = localStorage.getItem('campusName');


    this.dataService.getdata().subscribe((res: any) => {
      this.studentData = res.stdCounselCatmain;
      this.BehavioralReasons = this.getReasonsByCounselCatId(1);
      this.SocialConcerns = this.getReasonsByCounselCatId(2);
      this.selfAcademic = this.getReasonsByCounselCatId(3);
      this.Appearance = this.getReasonsByCounselCatId(4);
      this.Attitude = this.getReasonsByCounselCatId(5);
      this.MotorBehaviour = this.getReasonsByCounselCatId(6);
      this.Perceptions = this.getReasonsByCounselCatId(7);
      this.Affect = this.getReasonsByCounselCatId(8);
      this.Mood = this.getReasonsByCounselCatId(9);
      this.Speech = this.getReasonsByCounselCatId(10);
      this.Orientation = this.getReasonsByCounselCatId(11);
      this.ThoughtContent = this.getReasonsByCounselCatId(12);
      this.ThoughtProcess = this.getReasonsByCounselCatId(13);
      this.Memoryconcentration = this.getReasonsByCounselCatId(14);
      this.InsightJudgment = this.getReasonsByCounselCatId(15);
      this.AcademicConcerns = this.getReasonsByCounselCatId(16)
      this.EnviornmentalConcerns = this.getReasonsByCounselCatId(17)
      this.PersonalConcerns = this.getReasonsByCounselCatId(18)
      this.ConcernsCognition = this.getReasonsByCounselCatId(19)
      this.SelfharmSuicidalTendencies = this.getReasonsByCounselCatId(20)
    },
      (error) => {
        if (error.status === 401) {
          this.accessDenied = true;
        }
      }
    )
  }
  isItemChechecked(item: any) {
    let found: any;
    found = this.data?.stdCounselReasonsList?.stdCounselReasons.find((data: any) => data.counselCatRsnId == item.counselCatRsnId);
    return found ? true : false;

  }
  onKeydown(event: any) {

    if (event.key === "Enter") {
      this.search(this.searchCriteria)
      // this.applyFilter(event);
      console.log(event);
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
  assignPreviuosData(data: any) {
    data.map((item: any) => {

      if (item.counselCatId == 1) {
        this.totalBehavioralReasons = this.totalBehavioralReasons + 1;
      }
      if (item.counselCatId == 2) {
        this.totalSocialConcerns = this.totalSocialConcerns + 1;
      }
      if (item.counselCatId == 3) {
        this.totalselfAcademic = this.totalselfAcademic + 1;
      }
      if (item.counselCatId == 4) {
        this.totalAppearance = this.totalAppearance + 1;
      }
      if (item.counselCatId == 5) {
        this.totalAttitude = this.totalAttitude + 1;
      }
      if (item.counselCatId == 6) {
        this.totalMotorBehaviour = this.totalMotorBehaviour + 1;
      }
      if (item.counselCatId == 7) {
        this.totalPerceptions = this.totalPerceptions + 1;
      }
      if (item.counselCatId == 8) {
        this.totalAffect = this.totalAffect + 1;
      }
      if (item.counselCatId == 9) {
        this.totalMood = this.totalMood + 1;
      }
      if (item.counselCatId == 10) {
        this.totalSpeech = this.totalSpeech + 1;
      }
      if (item.counselCatId == 11) {
        this.totalOrientation = this.totalOrientation + 1;
      }
      if (item.counselCatId == 12) {
        this.totalThoughtContent = this.totalThoughtContent + 1;
      }
      if (item.counselCatId == 13) {
        this.totalThoughtProcess = this.totalThoughtProcess + 1;
      }
      if (item.counselCatId == 14) {
        this.totalMemoryconcentration = this.totalMemoryconcentration + 1;
      }
      if (item.counselCatId == 15) {
        this.totalInsightJudgment = this.totalInsightJudgment + 1;
      }
      if (item.counselCatId == 16) {
        this.totalacademicconcerns = this.totalacademicconcerns + 1;
      }
      if (item.counselCatId == 17) {
        this.totalEnviornmentalConcerns = this.totalEnviornmentalConcerns + 1;
      }
      if (item.counselCatId == 18) {
        this.totalpersonalconcerns = this.totalpersonalconcerns + 1;
      }
      if (item.counselCatId == 19) {
        this.totalconcernscognition = this.totalconcernscognition + 1;
      }
      if (item.counselCatId == 20) {
        this.totalselfharmsuicidaltendencies = this.totalselfharmsuicidaltendencies + 1;
      }

      this.stdCounselReasons.push({
        "counselCatRsnId": item.counselCatRsnId,
        "status": "True",
        "otherRemarks": item.otherRemarks,
        "none": item.none,
        "active": item.active,
        "passive": item.passive,
        "counselCatId": item.counselCatId
      });
      if (this.data.stdCounselReasonsList) {
        this.casenote = this.data?.stdCounselReasonsList.caseNotes;
      }

      if (this.data.stdCounselReasonsList) {
        this.referredBy = this.data?.stdCounselReasonsList.referredBy
      }
      if (this.data.stdCounselReasonsList) {
        this.anyOtherReasons = this.data?.stdCounselReasonsList.anyOtherReasons
      }

      if (this.data?.stdCounselReasonsList) {
        this.familyHistory = this.data?.stdCounselReasonsList.familyHistory
      }
      if (this.data?.stdCounselReasonsList) {
        this.caseHistory = this.data?.stdCounselReasonsList.caseHistory
      }
      if (this.data?.stdCounselReasonsList) {
        this.date = this.data?.stdCounselReasonsList.counselDate
      }
      if (this.data?.outcomeList) {
        this.refferalIfAny = this.data?.outcomeList[0].refferalIfAny
      }
      if (this.data?.outcomeList) {
        this.clinicalPsychologist = this.data?.outcomeList[0].clinicalPsychologist
      }
      if (this.data?.outcomeList) {
        this.psychiatrist = this.data?.outcomeList[0].psychiatrist
      }
      if (this.data?.outcomeList) {
        this.outCome = this.data?.outcomeList[0].outCome;
      }
      else {
        this.casenote = "No data";
      }
    })

  }
  getReasonsByCounselCatId(counselCatId: number): any[] {
    const category = this.studentData.find((cat: any) => cat.counselCatId === counselCatId);
    return category ? category.reasons : [];
  }

  onBehaviurSelect(item: any, event: any, isFromRadiaoButton: any) {
    if (item.reasonName === 'Others' && item.counselCatId === 1) {
      this.behavioral = !this.behavioral
    }
    else if (item.reasonName === 'Others' && item.counselCatId === 2) {
      this.socialconcerns = !this.socialconcerns
    }
    else if (item.reasonName === 'Others' && item.counselCatId === 3) {
      this.selfacademic = !this.selfacademic
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 4) {
      this.appearance = !this.appearance
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 5) {
      this.attitude = !this.attitude
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 6) {
      this.motorBehaviour = !this.motorBehaviour
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 7) {
      this.perceptions = !this.perceptions
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 8) {
      this.affect = !this.affect
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 9) {
      this.mood = !this.mood
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 10) {
      this.speech = !this.speech
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 11) {
      this.orientation = !this.orientation
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 12) {
      this.thoughtContent = !this.thoughtContent
    }
    else if (item.reasonName === 'Others' && item.counselCatId === 13) {
      this.thoughtProcess = !this.thoughtProcess
    }
    else if (item.reasonName === 'Others' && item.counselCatId === 14) {
      this.memoryconcentration = !this.memoryconcentration
    }
    else if (item.reasonName === 'Suicidal Ideation' && item.counselCatId === 12) {
      this.thoughtProcessradio = !this.thoughtProcessradio
    }
    else if (item.reasonName === 'Homicidal Ideation' && item.counselCatId === 12) {
      this.thoughtProcessradios = !this.thoughtProcessradios
    }
    if (!isFromRadiaoButton) {
      if (event.target.checked) {
        item.checked = true;
        for (let key in item) {

          if (key === 'counselCatRsnId') {
            if (item.counselCatId == 1) {
              this.totalBehavioralReasons = this.totalBehavioralReasons + 1;
            }
            if (item.counselCatId == 2) {
              this.totalSocialConcerns = this.totalSocialConcerns + 1;
            }
            if (item.counselCatId == 3) {
              this.totalselfAcademic = this.totalselfAcademic + 1;
            }
            if (item.counselCatId == 4) {
              this.totalAppearance = this.totalAppearance + 1;
            }
            if (item.counselCatId == 5) {
              this.totalAttitude = this.totalAttitude + 1;
            }
            if (item.counselCatId == 6) {
              this.totalMotorBehaviour = this.totalMotorBehaviour + 1;
            }
            if (item.counselCatId == 7) {
              this.totalPerceptions = this.totalPerceptions + 1;
            }
            if (item.counselCatId == 8) {
              this.totalAffect = this.totalAffect + 1;
            }
            if (item.counselCatId == 9) {
              this.totalMood = this.totalMood + 1;
            }
            if (item.counselCatId == 10) {
              this.totalSpeech = this.totalSpeech + 1;
            }
            if (item.counselCatId == 11) {
              this.totalOrientation = this.totalOrientation + 1;
            }
            if (item.counselCatId == 12) {
              this.totalThoughtContent = this.totalThoughtContent + 1;
            }
            if (item.counselCatId == 13) {
              this.totalThoughtProcess = this.totalThoughtProcess + 1;
            }
            if (item.counselCatId == 14) {
              this.totalMemoryconcentration = this.totalMemoryconcentration + 1;
            }
            if (item.counselCatId == 15) {
              this.totalInsightJudgment = this.totalInsightJudgment + 1;
            }
            if (item.counselCatId == 16) {
              this.totalacademicconcerns = this.totalacademicconcerns + 1;
            }
            if (item.counselCatId == 17) {
              this.totalEnviornmentalConcerns = this.totalEnviornmentalConcerns + 1;
            }
            if (item.counselCatId == 18) {
              this.totalpersonalconcerns = this.totalpersonalconcerns + 1;
            }
            if (item.counselCatId == 19) {
              this.totalconcernscognition = this.totalconcernscognition + 1;
            }
            if (item.counselCatId == 20) {
              this.totalselfharmsuicidaltendencies = this.totalselfharmsuicidaltendencies + 1;
            }
            this.stdCounselReasons.push({
              counselCatRsnId: item[key],
              "status": "True",
              "otherRemarks": "",
              "none": 'false',
              "active": 'false',
              "passive": 'false',
              "counselCatId": item.counselCatId
            });
          }
        }
      } else {
        if (item.counselCatId == 1) {
          this.totalBehavioralReasons = this.totalBehavioralReasons - 1;
        }
        if (item.counselCatId == 2) {
          this.totalSocialConcerns = this.totalSocialConcerns - 1;
        }
        if (item.counselCatId == 3) {
          this.totalselfAcademic = this.totalselfAcademic - 1;
        }
        if (item.counselCatId == 4) {
          this.totalAppearance = this.totalAppearance - 1;

        }
        if (item.counselCatId == 5) {
          this.totalAttitude = this.totalAttitude - 1;
        }
        if (item.counselCatId == 6) {
          this.totalMotorBehaviour = this.totalMotorBehaviour - 1;
        }
        if (item.counselCatId == 7) {
          this.totalPerceptions = this.totalPerceptions - 1;
        }
        if (item.counselCatId == 8) {
          this.totalAffect = this.totalAffect - 1;
        }
        if (item.counselCatId == 9) {
          this.totalMood = this.totalMood - 1;
        }
        if (item.counselCatId == 10) {
          this.totalSpeech = this.totalSpeech - 1;
        }
        if (item.counselCatId == 11) {
          this.totalOrientation = this.totalOrientation - 1;
        }
        if (item.counselCatId == 12) {
          this.totalThoughtContent = this.totalThoughtContent - 1;
        }
        if (item.counselCatId == 13) {
          this.totalThoughtProcess = this.totalThoughtProcess - 1;
        }
        if (item.counselCatId == 14) {
          this.totalMemoryconcentration = this.totalMemoryconcentration - 1;
        }
        if (item.counselCatId == 15) {
          this.totalInsightJudgment = this.totalInsightJudgment - 1;
        }
        if (item.counselCatId == 16) {
          this.totalacademicconcerns = this.totalacademicconcerns - 1;
        }
        if (item.counselCatId == 17) {
          this.totalEnviornmentalConcerns = this.totalEnviornmentalConcerns - 1;
        }
        if (item.counselCatId == 18) {
          this.totalpersonalconcerns = this.totalpersonalconcerns - 1;
        }
        if (item.counselCatId == 19) {
          this.totalconcernscognition = this.totalconcernscognition - 1;
        }
        if (item.counselCatId == 20) {
          this.totalselfharmsuicidaltendencies = this.totalselfharmsuicidaltendencies - 1;
        }
        else {
          item.checked = false;
          this.stdCounselReasons = this.stdCounselReasons.filter((item1: any) => item1.counselCatRsnId != item.counselCatRsnId)
        }

      }
    } else {
      if (!event.target.checked == false) {
        let isFound = this.stdCounselReasons.filter((item1: any) => item1.counselCatId == item.counselCatId);
        if (isFound) {
          this.stdCounselReasons = this.stdCounselReasons.filter((item1: any) => item1.counselCatId != item.counselCatId);

          this.stdCounselReasons.push({
            counselCatRsnId: item.counselCatRsnId,
            "status": "True",
            "otherRemarks": "",
            "none": 'false',
            "active": 'false',
            "passive": 'false',
            "counselCatId": item.counselCatId
          });
          this.incrementCategoryCounts(item.counselCatId);
        } else {

          this.stdCounselReasons.push({
            counselCatRsnId: item.counselCatRsnId,
            "status": "True",
            "otherRemarks": "",
            "none": 'false',
            "active": 'false',
            "passive": 'false',
            "counselCatId": item.counselCatId
          });;
        }
        // this.incrementCategoryCounts(item.counselCatId);
        console.log(item);
        console.log(this.stdCounselReasons)
      }
    }
  }
  incrementCategoryCounts(counselCatId: any) {
    switch (counselCatId) {
      case 16:
        this.totalacademicconcerns++;
        break;
      case 17:
        this.totalEnviornmentalConcerns++;
        break;
      case 18:
        this.totalpersonalconcerns++;
        break;

      case 19:
        this.totalconcernscognition++;
        break;
      case 20:
        this.totalselfharmsuicidaltendencies++;
        break;
      case 15:
        this.totalInsightJudgment++;
        break;
    }
  }
  onChange(reasonId: any, event: any) {
    this.stdCounselReasons.map((item: any) => {
      if (item.counselCatRsnId == reasonId) {
        item.otherRemarks = event.target.value;
        return
      }
    })
  }
  hasValidCounselCatId(data: any) {
    const validCounselCatIds = new Set();
    for (let i = 0; i < data.length; i++) {
      const counselCatId = data[i].counselCatId;
      if (counselCatId >= 1 && counselCatId <= 15) {
        validCounselCatIds.add(counselCatId);
      }
    }

    for (let i = 1; i <= 15; i++) {
      if (!validCounselCatIds.has(i)) {
        return false;
      }
    }
    return true;
  }
  onSubmit() {

    if (this.searchCriteria === "") {
      window.alert("Please  enter the valid  Admission number")
      return
    }

    if (this.totalBehavioralReasons == 0) {
      window.alert("Please select atleast one Behavioral Reasons!")
      this.inputField.nativeElement.focus();
      return
    }
    if (this.totalSocialConcerns == 0) {
      window.alert("Please select atleast one Social Concerns Reasons!")
      this.inputField1.nativeElement.focus();
      return
    }
    if (this.totalselfAcademic == 0) {
      window.alert("Please select atleast one self/Academic Reasons!")
      this.inputField2.nativeElement.focus();
      return
    }
    // if (this.totalacademicconcerns == 0) {
    //   window.alert("Please select atleast one AcademicConcerns Reasons!")
    //   this.inputField15.nativeElement.focus();
    //   return
    // }
    // if (this.totalEnviornmentalConcerns == 0) {
    //   window.alert("Please select atleast one EnviornmentalConcerns Reasons!")
    //   this.inputField16.nativeElement.focus();
    //   return
    // }
    // if (this.totalpersonalconcerns == 0) {
    //   window.alert("Please select atleast one PersonalConcerns Reasons!")
    //   this.inputField17.nativeElement.focus();
    //   return
    // }
    // if (this.totalconcernscognition == 0) {
    //   window.alert("Please select atleast one ConcernsCognition Reasons!")
    //   this.inputField18.nativeElement.focus();
    //   return
    // }
    // if (this.totalselfharmsuicidaltendencies == 0) {
    //   window.alert("Please select atleast one SelfHarmSuicidalTendencies Reasons!")
    //   this.inputField19.nativeElement.focus();
    //   return
    // }
    if (this.totalAppearance == 0) {
      window.alert("Please select atleast one Appearance Reasons!")
      this.inputField3.nativeElement.focus();
      return
    }
    if (this.totalAttitude == 0) {
      window.alert("Please select atleast one Attitude Reasons!")
      this.inputField4.nativeElement.focus();
      return
    }
    if (this.totalMotorBehaviour == 0) {
      window.alert("Please select atleast one Motor Behaviour Reasons!")
      this.inputField5.nativeElement.focus();
      return
    }
    if (this.totalPerceptions == 0) {
      window.alert("Please select atleast one Perceptions Reasons!")
      this.inputField6.nativeElement.focus();
      return
    }
    if (this.totalAffect == 0) {
      window.alert("Please select atleast one Affect Reasons!")
      this.inputField7.nativeElement.focus();
      return
    }
    if (this.totalMood == 0) {
      window.alert("Please select atleast one Mood Reasons!")
      this.inputField8.nativeElement.focus();
      return
    }
    if (this.totalSpeech == 0) {
      window.alert("Please select atleast one Speech Reasons!")
      this.inputField9.nativeElement.focus();
      return
    }
    if (this.totalOrientation == 0) {
      window.alert("Please select atleast one Orientation Reasons!")
      this.inputField10.nativeElement.focus();
      return
    }
    if (this.totalThoughtContent == 0) {
      window.alert("Please select atleast one Thought Content Reasons!")
      this.inputField11.nativeElement.focus();
      return
    }
    if (this.totalThoughtProcess == 0) {
      window.alert("Please select atleast one Thought Process Reasons!")
      this.inputField12.nativeElement.focus();
      return
    }
    if (this.totalMemoryconcentration == 0) {
      window.alert("Please select atleast one Memory/concentration Reasons!")
      this.inputField13.nativeElement.focus();
      return
    } if (this.totalInsightJudgment == 0) {
      window.alert("Please select atleast one Insight/Judgment Reasons!");
      this.inputField14.nativeElement.focus();
      return
    }

    if (document.getElementById('behavioralId') != null && this.profileForm.value.behavioral == null || this.profileForm.value.behavioral == "") {
      window.alert("Please Enter behavioral Text Box !");
      return
    }
    if (document.getElementById('socialconcernsId') != null && this.profileForm.value.socialconcerns == null || this.profileForm.value.socialconcerns == "") {
      window.alert("Please Enter socialconcerns Text Box !");
      return
    }
    if (document.getElementById('selfacademicId') != null && this.profileForm.value.selfacademic == null || this.profileForm.value.selfacademic == "") {
      window.alert("Please Enter selfacademic Text Box !");
      return
    }
    if (document.getElementById('txtApappearanceId') != null && this.profileForm.value.appearance == null || this.profileForm.value.appearance == "") {
      window.alert("Please Enter appearance Text Box !");
      return
    }
    if (document.getElementById('txtAttitudeId') != null && this.profileForm.value.attitude == null || this.profileForm.value.attitude == "") {
      window.alert("Please Enter Attitude Text Box !");
      return
    }
    if (document.getElementById('MotorBehaviourId') != null && this.profileForm.value.motorBehaviour == null || this.profileForm.value.motorBehaviour == "") {
      window.alert("Please Enter MotorBehaviour Text Box !");
      return
    }
    if (document.getElementById('PerceptionsId') != null && this.profileForm.value.perceptions == null || this.profileForm.value.perceptions == "") {
      window.alert("Please Enter PerceptionsValue Text Box !");
      return
    }
    if (document.getElementById('AffectId') != null && this.profileForm.value.affect == null || this.profileForm.value.affect == "") {
      window.alert("Please Enter AffectValue Text Box !");
      return
    }

    if (document.getElementById('MoodId') != null && this.profileForm.value.mood == null || this.profileForm.value.mood == "") {
      window.alert("Please Enter MoodValue Text Box !");
      return
    }
    if (document.getElementById('SpeechId') != null && this.profileForm.value.speech == null || this.profileForm.value.speech == "") {
      window.alert("Please Enter SpeechValue Text Box !");
      return
    }
    if (document.getElementById('Orientation') != null && this.profileForm.value.Orientation == null || this.profileForm.value.Orientation == "") {
      window.alert("Please Enter OrientationValue Text Box !");
      return
    }
    if (document.getElementById('thoughtContentId') != null && this.profileForm.value.thoughtContent == null || this.profileForm.value.thoughtContent == "") {
      window.alert("Please Enter thoughtContentValue Text Box !");
      return
    }
    if (document.getElementById('thoughtProcessId') != null && this.profileForm.value.thoughtProcess == null || this.profileForm.value.thoughtProcess == "") {
      window.alert("Please Enter thoughtProcessValue Text Box !");
      return
    }
    if (document.getElementById('MemoryConcentrationId') != null && this.profileForm.value.MemoryConcentration == null || this.profileForm.value.MemoryConcentration == "") {
      window.alert("Please Enter MemoryConcentrationValue Text Box !");
      return
    }
    if (document.getElementById('inlineRadioOptions') != null && this.throughtContent == "") {
      window.alert("Please Enter Suicidal Ideation radio button values!");
      return
    }
    if (document.getElementById('inlineRadioOptions1') != null && this.throughtContents == "") {
      window.alert("Please Enter Homicidal Ideation  radio button Value !");
      return
    }

    let isVAlid: any = this.hasValidCounselCatId(this.stdCounselReasons);
    if (isVAlid && this.profileForm.value.caseNotes && this.profileForm.value.counselDate) {
      if ('followUpList' in this.data && 'stdCounselReasonsList' in this.data && 'outcomeList' in this.data) {
        let date = this.profileForm.value.followUpdate
        let follow = this.profileForm.value.followUp
        if (!date || date == "Invalid date") {
          window.alert("Please enter followup date")
          return
        }
        if (follow == null || follow == '') {
          window.alert("Please enter followup  text box")
          return
        }
      }
      let data = {
        "admNo": this.searchCriteria,
        "referredBy": this.profileForm.value.referredBy,
        "anyOtherReasons": this.profileForm.value.anyOtherReasons,
        "caseHistory": this.profileForm.value.caseHistory,
        "familyHistory": this.profileForm.value.familyHistory,
        "caseNotes": this.profileForm.value.caseNotes,
        "followUp": this.profileForm.value.followUp,
        "outCome": this.profileForm.value.outCome,
        "refferalIfAny": this.profileForm.value.refferalIfAny,
        "clinicalPsychologist": this.profileForm.value.clinicalPsychologist,
        "psychiatrist": this.profileForm.value.psychiatrist,
        "counselDate": moment(this.profileForm.value.counselDate).format('DD-MMM-YYYY'),
        "followUpDate": (moment(this.profileForm.value.followUpdate).format('DD-MMM-YYYY')) == "Invalid date" ? '' : (moment(this.profileForm.value.followUpdate).format('DD-MMM-YYYY')),
        "stdCounselReasons": this.stdCounselReasons
      }

      if (confirm('do you want to save Counselling Notes Details')) {

        this.dataService.savedata(data).subscribe(res => {
        })
        window.alert("Confidential Counselling Notes Details Saved Successfully")
        this.toast.showSuccess("Confidential Counselling Notes Details Saved Successfully")
        this.resetform()
        this.sumbited = false
        this.data = null;
        this.searchCriteria = '';
        this.stdCounselReasons = []
      } else {
      }
    }

    else if (this.profileForm.value.counselDate == null) {
      window.alert("please select the counselling Date ")
      this.counseldate11.nativeElement.focus();
    }
    else {
      console.log('invalid form')
      window.alert("please enter the casenote mesage ")
      this.casenotechecked.nativeElement.focus();

    }
  }
  search(searchCriteria: string) {

    this.isButtonDisabled = false

    this.totalBehavioralReasons = 0
    this.totalSocialConcerns = 0;
    this.totalselfAcademic = 0;
    this.totalAppearance = 0;
    this.totalAttitude = 0;
    this.totalMotorBehaviour = 0;
    this.totalPerceptions = 0;
    this.totalAffect = 0;
    this.totalMood = 0;
    this.totalSpeech = 0;
    this.totalOrientation = 0;
    this.totalThoughtContent = 0;
    this.totalThoughtProcess = 0;
    this.totalMemoryconcentration = 0;
    this.totalInsightJudgment = 0;
    this.totalacademicconcerns = 0;
    this.totalEnviornmentalConcerns = 0;
    this.totalpersonalconcerns = 0;
    this.totalconcernscognition = 0;
    this.totalselfharmsuicidaltendencies = 0;

    this.throughtContent = ""
    this.throughtContents = ""

    this.selectedOption = false;
    this.dataService.getdata().subscribe(((res: any) => {
      this.studentData = res.stdCounselCatmain;
      this.BehavioralReasons = this.getReasonsByCounselCatId(1);
      this.SocialConcerns = this.getReasonsByCounselCatId(2);
      this.selfAcademic = this.getReasonsByCounselCatId(3);
      this.Appearance = this.getReasonsByCounselCatId(4);
      this.Attitude = this.getReasonsByCounselCatId(5);
      this.MotorBehaviour = this.getReasonsByCounselCatId(6);
      this.Perceptions = this.getReasonsByCounselCatId(7);
      this.Affect = this.getReasonsByCounselCatId(8);
      this.Mood = this.getReasonsByCounselCatId(9);
      this.Speech = this.getReasonsByCounselCatId(10);
      this.Orientation = this.getReasonsByCounselCatId(11);
      this.ThoughtContent = this.getReasonsByCounselCatId(12);
      this.ThoughtProcess = this.getReasonsByCounselCatId(13);
      this.Memoryconcentration = this.getReasonsByCounselCatId(14);
      this.InsightJudgment = this.getReasonsByCounselCatId(15);
      this.AcademicConcerns = this.getReasonsByCounselCatId(16)
      this.EnviornmentalConcerns = this.getReasonsByCounselCatId(17)
      this.PersonalConcerns = this.getReasonsByCounselCatId(18)
      this.ConcernsCognition = this.getReasonsByCounselCatId(19)
      this.SelfharmSuicidalTendencies = this.getReasonsByCounselCatId(20)
    }))
    this.dataService.searchData(searchCriteria).subscribe((response) => {
      this.data = response
      if (this.data.status == "NOT_FOUND") {
        this.snackbar.open('Invalid Student Details... ', 'Close', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'end',
        });
      }
      if (this.data?.followUpList[this.data?.followUpList.length - 1].followUp !== '') {
        this.lastFollowUpDate = this.findLastFollowUpDate(this.data?.followUpList);
      }
      else {
        this.lastFollowUpDate = this.data?.stdCounselReasonsList.counselDate
      }



      let otherdata = this.data?.stdCounselReasonsList?.stdCounselReasons?.filter((item: any) => {
        return item.otherRemarks != ""
      })
      let radiodata = this.data?.stdCounselReasonsList?.stdCounselReasons?.filter((item: any) => {
        return item.passive || item.active || item.none == true
      })
      if ('followUpList' in this.data && 'stdCounselReasonsList' in this.data && 'outcomeList' in this.data) {
        this.isButtonDisabled = true
      }
      otherdata?.map((item: any) => {
        if (item.counselCatRsnId === 29) {
          this.behavioral = !this.behavioral
          this.profileForm.controls['behavioral'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 29) {
          this.socialconcerns = !this.socialconcerns
          this.profileForm.controls['socialconcerns'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 29) {
          this.selfacademic = !this.selfacademic
          this.profileForm.controls['selfacademic'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 29) {
          this.appearance = !this.appearance
          this.profileForm.controls['appearance'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 32) {
          this.attitude = !this.attitude
          this.profileForm.controls['attitude'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 35) {
          this.motorBehaviour = !this.motorBehaviour
          this.profileForm.controls['motorBehaviour'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 38) {
          this.perceptions = !this.perceptions
          this.profileForm.controls['perceptions'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 45) {
          this.affect = !this.affect
          this.profileForm.controls['affect'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 51) {
          this.mood = !this.mood
          this.profileForm.controls['mood'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 56) {
          this.speech = !this.speech
          this.profileForm.controls['speech'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 62) {
          this.orientation = !this.orientation
          this.profileForm.controls['Orientation'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 68) {
          this.thoughtContent = !this.thoughtContent
          this.profileForm.controls['thoughtContent'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 73) {
          this.thoughtProcess = !this.thoughtProcess
          this.profileForm.controls['thoughtProcess'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 78) {
          this.memoryconcentration = !this.memoryconcentration
          this.profileForm.controls['MemoryConcentration'].setValue(item.otherRemarks)
        }
      })
      radiodata?.map((item: any) => {
        if (item.counselCatRsnId === 63) {
          this.throughtContent = item
          this.thoughtProcessradio = !this.thoughtProcessradio
        }
        if (item.counselCatRsnId === 64) {
          this.throughtContents = item
          this.thoughtProcessradios = !this.thoughtProcessradios
        }
      })
      if (this.data) {
        this.assignPreviuosData(this.data.stdCounselReasonsList.stdCounselReasons)
      }
    });
    this.resetform()
    this.stdCounselReasons = []
  }
  radio(data: any, value: any) {
    this.stdCounselReasons.map((item: any) => {
      if (item.counselCatRsnId == data.counselCatRsnId) {
        if (value == 'none') {
          item.none = true;
          item.active = false;
          item.passive = false
        } else if (value == 'active') {
          item.active = true;
          item.passive = false
          item.none = false;
        } else if (value == 'passive') {
          item.passive = true;
          item.none = false;
          item.active = false;
        }

        (item.counselCatRsnId === 63) ? this.throughtContent = item : this.throughtContents = item;
        return
      }
    })
  }

  resetform() {
    this.profileForm.reset()
    var checkBoxObjects = document.getElementsByClassName('form-check-input') as HTMLCollection
    for (let index = 0; index < checkBoxObjects.length; index++) {
      const element = checkBoxObjects[index];
      //@ts-ignore
      element.checked = false;
      this.behavioral = false;
      this.socialconcerns = false;
      this.selfacademic = false
      this.appearance = false;
      this.attitude = false;
      this.motorBehaviour = false;
      this.perceptions = false;
      this.affect = false;
      this.mood = false;
      this.speech = false;
      this.orientation = false;
      this.thoughtContent = false;
      this.thoughtProcess = false;
      this.memoryconcentration = false;
      this.thoughtProcessradios = false;
      this.thoughtProcessradio = false;
    }
  }

  findLastFollowUpDate(followUpList: any[]): string {
    let lastDate: Date = new Date(0); // Initialize with a minimal date
    for (const followUp of followUpList) {
      const followUpDate = new Date(followUp.followUpDate);
      if (followUpDate > lastDate) {
        lastDate = followUpDate;
      }
    }
    return lastDate.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
  }

  Logout() {

    const logoutPage = localStorage.getItem('logoutPage')
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }


}
